import type { FaireProductEntity } from "../../entity_types/product";

export const p_57yh2dgkqf: FaireProductEntity = {
  token: "p_57yh2dgkqf",
  type: "product",
  name: "Boat Block Puzzle",
  brandToken: "b_f4xfzytua7",
  brandName: "Speedy Monkey",
  imageUrl:
    "https://cdn.faire.com/fastly/267cd58bf451bbd227ca2ddf6d4f78d63a19563a81594cf005f00596a12db302.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a705c38370de8fca715eeab8e403e972866cbf68dc458f74559fe24008db0e6.jpeg",
    "https://cdn.faire.com/fastly/29ef23114765f8475d092d408778889966e51150a82b2deb5f3247a94ebeeb55.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "Introducing Boat Block Puzzle! \nBuild, explore, and set sail with the Boat Block Puzzle, where every piece leads to discovery! \n\nSet sail on a sea of learning with the Boat Block Puzzle, a vibrant and interactive wooden toy that combines imaginative play with early skill-building. With 15 colorful wooden blocks, little ones can build, stack, and sort while exploring shapes, patterns, and coordination.\nPerfect for children 12 months and up, this nautical-themed puzzle encourages fine motor development, hand-eye coordination, and problem-solving in a fun and engaging way. Whether your child is arranging the pieces on the board or creating their own boat designs, the Boat Block Puzzle brings hours of hands-on, screen-free play.\nMade with FSC-certified wood via our FSC-Certified manufacturing partner and non-toxic, child-safe paints, Speedy Monkey toys meet ASTM F963, California Prop 65, and international safety standards, letting children play safely and imaginatively.\n\nSmooth edges make it safe for tiny hands, and when the adventure is over, just wipe clean with a damp cloth for easy care. \n\nSpecifications:\n Color: Multicolor\n Recommended Age: 12m+\n Material: Wood - FSC certified from our certified supplier\n Size (inches): L 10.31 x W 7.95 x H 0.83 in \n Weight (lbs): 1.02\n\n",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:17.341Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
